import axios from '@/utils/request';


// 分销者列表
export const fxzList = (data) => {
    return axios.post('/dataScreen/listAll/getUserListAll',data);
};

